<template>
	<div class="cargo-card__header">
		<TypographyKTypographyBody4
			:color="
				pickupStatusesComp?.get(request?.cargoPickupDetail?.cargoPickupStatusId)?.backgroundColor || 'var(--black)'
			"
			font-type="semi-bold"
			>Груз {{ request?.number }}</TypographyKTypographyBody4
		>
		<PagesCargosStatus
			:status="request.cargoStatus"
			v-if="request.cargoStatus"
		></PagesCargosStatus>
		<div class="weight">
			<UiIcon
				name="weight"
				folder="cargos"
				width="20px"
				height="20px"
				:color="pickupStatusesComp?.get(request?.cargoPickupDetail?.cargoPickupStatusId)?.backgroundColor || undefined"
			/>

			<div class="weight-info">
				<TypographyKTypographyBody6
					color="var(--black)"
					font-type="regular"
				>
					Вес
				</TypographyKTypographyBody6>
				<TypographyKTypographyBody6
					color="var(--black)"
					font-type="bold"
				>
					{{ request?.weightFact || '-' }} т
				</TypographyKTypographyBody6>
			</div>
		</div>
	</div>
	<div class="cargo-card__info">
		<div class="info-sender__wrapper">
			<div class="info-sender">
				<TypographyKTypographyBody5 class="title"> Отправитель: </TypographyKTypographyBody5>
				<TypographyKTypographyBody5
					class="sub-title"
					font-type="regular"
					color="var(--dark-primary)"
				>
					{{ request?.clientSender?.name || '-' }}
				</TypographyKTypographyBody5>
			</div>
			<div class="info-sender">
				<TypographyKTypographyBody5 class="title"> Получатель: </TypographyKTypographyBody5>
				<TypographyKTypographyBody5
					class="sub-title"
					font-type="regular"
					color="var(--dark-primary)"
				>
					{{ request?.clientRecipient?.name || '-' }}
				</TypographyKTypographyBody5>
			</div>
		</div>
	</div>
	<div class="cargo-card__description">
		<div class="wrapper">
			<div class="group">
				<TypographyKTypographyBody5
					font-type="bold"
					color="var(--dark-primary)"
				>
					{{ 'Наименование: ' }}
				</TypographyKTypographyBody5>
				<TypographyKTypographyBody5
					font-type="regular"
					color="var(--dark-primary)"
					>{{ request.name }}</TypographyKTypographyBody5
				>
			</div>
			<div class="group">
				<TypographyKTypographyBody5
					font-type="bold"
					color="var(--dark-primary)"
				>
					{{ 'Комментарий: ' }}
				</TypographyKTypographyBody5>
				<TypographyKTypographyBody5
					font-type="regular"
					color="var(--dark-primary)"
				>
					<span v-html="request?.comment"></span>
				</TypographyKTypographyBody5>
			</div>
			<div class="group">
				<TypographyKTypographyBody5
					font-type="bold"
					color="var(--dark-primary)"
				>
					{{ 'Город: ' }}
				</TypographyKTypographyBody5>
				<TypographyKTypographyBody5
					font-type="regular"
					color="var(--dark-primary)"
					><span v-html="request?.city?.name"></span
				></TypographyKTypographyBody5>
			</div>
		</div>
	</div>
	<div
		class="cargo-card__status"
		:style="{
			backgroundColor:
				pickupStatusesComp?.get(request?.cargoPickupDetail?.cargoPickupStatusId)?.backgroundColor ||
				request?.cargoStatus?.backgroundColor
		}"
		v-if="isNeedStatusCargo"
	>
		<TypographyKTypographyBody4
			:color="
				pickupStatusesComp?.get(request?.cargoPickupDetail?.cargoPickupStatusId)?.fontColor ||
				request?.cargoStatus?.fontColor
			"
			font-type="bold"
		>
			{{ pickupStatusesComp?.get(request?.cargoPickupDetail?.cargoPickupStatusId)?.name || request?.cargoStatus?.name }}
		</TypographyKTypographyBody4>
	</div>
</template>

<script setup lang="ts">
	import { useDictionariesStore } from '~/store/dictionaries.store';
	import type { IDriverRequestsItem } from '~~/shared/interfaces/driverRequests';

	const emits = defineEmits(['addedComment']);
	const props = withDefaults(
		defineProps<{
			request: IDriverRequestsItem;
			minHeight?: string;
			isNeedStatusCargo?: boolean;
			isNeedMoreInfo?: boolean;
		}>(),
		{
			minHeight: '190px',
			isNeedStatusCargo: true,
			isNeedMoreInfo: false
		}
	);

	const dictionariesStrore = useDictionariesStore();
	const pickupStatusesComp = storeToRefs(dictionariesStrore).storekeeperStatuses;
</script>

<style scoped lang="scss">
	.cargo-card {
		&__description {
			display: flex;
			align-items: center;
			background-color: var(--gray-primary);
			border-radius: 12px;
			margin-top: 6px;
			padding: 12px 14px;

			.wrapper {
				display: flex;
				flex-direction: column;
				gap: 6px;

				.group {
					display: flex;
					flex-direction: column;
					gap: 4px;
				}
			}
		}

		&__info {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 4px;
			margin-top: 8px;

			.info-sender__wrapper {
				display: flex;
				flex-direction: column;
				gap: 1px;
				width: 100%;

				.info-sender {
					display: flex;
					gap: 5px;
					width: 100%;

					.title {
						width: fit-content;
						font-weight: 600;
					}
				}
			}

			.phone-wrapper {
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 5px 15px;
				border-radius: 15px;
				background-color: var(--gray-primary);
				cursor: pointer;

				&_disabled {
					cursor: not-allowed;
					opacity: 0.5;
					pointer-events: none;

					&::after {
						content: '';
						position: absolute;
						top: 0px;
						right: 50%;
						height: 100%;
						width: 2px;
						background-color: var(--red);
						opacity: 1;
						rotate: 45deg;
						border-radius: 10px;
					}
				}
			}

			.title {
				width: 100%;
				max-width: 300px;
			}
		}

		&__status {
			position: absolute;
			display: flex;
			align-items: center;
			justify-content: center;
			top: 0px;
			right: -1px;
			height: 100%;
			width: 33px;
			writing-mode: vertical-rl;
			border-radius: 16px 0px 0px 16px;
			transform: translate(0%, 0%) rotate(-180deg);
			white-space: nowrap;
		}

		&__header {
			display: flex;
			align-items: center;
			width: 100%;
			gap: 8px;

			.weight {
				display: flex;
				align-items: center;
				gap: 2px;
				margin-left: auto;

				&-info {
					display: flex;
					flex-direction: column;
				}
			}
		}
	}
</style>
